import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    return http.get('/api/detro-tasks?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  forcarExecucaoTask (id) {
    return http.post(`/api/detro-tasks/${id}/executar`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteTask (id) {
    return http.delete('/api/detro-tasks/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/tasks-detro/services/tasks.js